import http from "./http";

// Pauta Inteligente: chama o Laravel (auth Bearer), que coleta + anonimiza as
// consultas do medico no periodo informado e delega a IA no nutria-comunicacao.
// Este fluxo passa pelo dominio do Laravel (auth Bearer), nao por um servico
// FastAPI standalone.

/**
 * Gera as sugestoes de pauta (temas para redes sociais) de um medico.
 *
 * @param {number|string} doctorId
 * @param {{ dataInicio: string, dataFim: string }} periodo  datas YYYY-MM-DD
 * @returns {Promise<{success: boolean, data?: object, message?: string}>}
 *   data = SocialMediaThemeSuggestionResponse
 *   { analyzed_period, total_theme_groups, theme_groups[], summary }
 */
export async function gerarPautaInteligente(doctorId, { dataInicio, dataFim }) {
  const { data } = await http.post(`/api/pauta-inteligente/doctor/${doctorId}`, {
    data_inicio: dataInicio,
    data_fim: dataFim,
  });
  return data;
}

/**
 * Etapa 5 — sugere formatos de conteudo a partir do tema escolhido.
 *
 * @param {object} tema  o grupo de tema escolhido (SocialMediaThemeGroup)
 * @returns {Promise<{success: boolean, data?: object, message?: string}>}
 *   data = ContentFormatSuggestionResponse
 *   { theme, total_formats, formats[], summary }
 */
export async function sugerirFormatos(tema) {
  const { data } = await http.post(`/api/pauta-inteligente/formatos`, { tema });
  return data;
}

/**
 * Etapa 6 — gera a peca de conteudo final a partir do tema e do formato escolhidos.
 *
 * @param {object} tema     o grupo de tema escolhido (SocialMediaThemeGroup)
 * @param {object} formato  o formato escolhido (ContentFormatSuggestion)
 * @returns {Promise<{success: boolean, data?: object, message?: string}>}
 *   data = ContentPieceResponse
 *   { theme, format_type, hook, blocks[], caption, cta, hashtags[] }
 */
export async function gerarConteudo(tema, formato) {
  const { data } = await http.post(`/api/pauta-inteligente/conteudo`, {
    tema,
    formato,
  });
  return data;
}
